function VideosCtrl($http, $sce, $scope, $timeout) {
  const ctrl = this;
  ctrl.$onInit = function () {
    $scope.$watch('videos.videoId', newVal => {
      if (newVal) {
        ctrl.getVideoById(newVal).then(response => ctrl.processResult([response.data]));
      }
    });

    // автозапуск включили на уже показанном видео — перерисовываем плеер
    $scope.$watch('videos.autoplay', (newVal, oldVal) => {
      if (newVal === true && newVal !== oldVal && ctrl.videoId) {
        ctrl.getVideoById(ctrl.videoId).then(response => ctrl.processResult([response.data]));
      }
    });
    $scope.$watch('videos.productId', newVal => {
      if (newVal) {
        ctrl.getVideos(newVal).then(response => ctrl.processResult(response.data));
      }
    });
  };
  ctrl.getVideos = function (newVal) {
    return $http.get('productExt/getvideos', {
      params: {
        productId: newVal
      }
    });
  };
  ctrl.getVideoById = function (newVal) {
    return $http.get('productExt/getVideoById', {
      params: {
        videoId: newVal
      }
    });
  };

  // PlayerCode хранится в БД без постера, поэтому cover проставляется здесь
  ctrl.applyPoster = function (playerCode, posterSrc) {
    if (!playerCode || !posterSrc || playerCode.indexOf('<iframe-responsive') === -1 || playerCode.indexOf('cover=') !== -1) {
      return playerCode;
    }
    return playerCode.replace('<iframe-responsive', `<iframe-responsive cover="${posterSrc.replace(/"/g, '&quot;')}"`);
  };

  // запуск по действию пользователя (например, клик по миниатюре видео в карусели)
  ctrl.applyAutoplay = function (playerCode) {
    if (!playerCode || playerCode.indexOf('<iframe-responsive') === -1 ||
    // атрибут уже задан (параметр autoplay в ссылке src не в счёт)
    /<iframe-responsive\b[^>]*\s(data-)?autoplay\s*=/i.test(playerCode)) {
      return playerCode;
    }
    return playerCode.replace('<iframe-responsive', '<iframe-responsive autoplay="true"');
  };
  ctrl.processResult = function (data) {
    ctrl.videos = data;
    for (let i = 0; i < ctrl.videos.length; i++) {
      const video = ctrl.videos[i];
      let playerCode = ctrl.applyPoster(video.PlayerCode, video.PosterSrc);
      if (ctrl.autoplay === true) {
        playerCode = ctrl.applyAutoplay(playerCode);
      }
      video.PlayerCode = $sce.trustAsHtml(playerCode);
    }
    if (ctrl.onReceive) {
      $timeout(() => {
        ctrl.onReceive({});
      });
    }
    return data;
  };
}
VideosCtrl.$inject = ["$http", "$sce", "$scope", "$timeout"];
export default VideosCtrl;